import * as React from "react";
import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Box,
    Checkbox,
    FormControlLabel,
    Grid
} from "@mui/material";
import Button from "@mui/material/Button";
import {toast} from "react-toastify";
import LoadingDialog from "../../components/loadingDialog";
import {campusStatesReplace, getCampusStates} from "./programSetService";

export default function ProgramSetStatesModal(params: {programSetId: number, campus: any, setCampus: any, reload: any}) {
    const [loading, setLoading] = React.useState(false);
    const [states, setStates] = React.useState([] as any[]);
    const [selected, setSelected] = React.useState({} as any);

    React.useEffect(() => {
        if (!params.campus) {
            setStates([]);
            setSelected({});
            return;
        }

        setLoading(true);
        getCampusStates(params.programSetId, params.campus.name).then((list: any[]) => {
            const map: any = {};
            list.forEach((s) => { map[s.state] = s.checked; });
            setStates(list);
            setSelected(map);
            setLoading(false);
        });
    }, [params.campus, params.programSetId]);

    const handleClose = (event?: any, reason?: any) => {
        if (reason && reason === "backdropClick")
            return;
        params.setCampus(null);
    };

    const toggleAll = () => {
        const allChecked = states.every((s) => selected[s.state]);
        const map: any = {};
        states.forEach((s) => { map[s.state] = !allChecked; });
        setSelected(map);
    }

    const handleSubmit = async () => {
        setLoading(true);
        const chosen = states.filter((s) => selected[s.state]).map((s) => s.state);
        const good = await campusStatesReplace(params.programSetId, params.campus.name, chosen);

        if (good) {
            toast.success('States updated successfully');
            setLoading(false);
            handleClose();
            params.reload();
        } else {
            setLoading(false);
        }
    }

    if (!params.campus) return <> </>;

    return (
        <Dialog
            open={!!params.campus}
            onClose={handleClose}
            maxWidth={'md'}
            fullWidth={true}
        >
            <DialogTitle>
                States - {params.campus.name}
            </DialogTitle>
            <DialogContent>
                <Box sx={{margin: '5px 0', fontSize: '13px'}}>
                    Selected states replace all zips for this campus.
                </Box>
                <FormControlLabel
                    control={<Checkbox checked={states.length > 0 && states.every((s) => selected[s.state])} onChange={toggleAll} />}
                    label={<b>Check/Uncheck All</b>}
                />
                <Grid container spacing={0}>
                    {states.map((s: any) => (
                        <Grid item xs={12} sm={6} md={4} key={s.state}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        size={'small'}
                                        checked={!!selected[s.state]}
                                        onChange={(e) => setSelected({...selected, [s.state]: e.target.checked})}
                                    />
                                }
                                label={s.name}
                            />
                        </Grid>
                    ))}
                </Grid>
            </DialogContent>
            {loading ? <LoadingDialog/> :
                <DialogActions>
                    <Button sx={{color: 'red'}} onClick={handleClose}>Close</Button>
                    <Button sx={{color: 'green'}} onClick={handleSubmit} autoFocus>Update</Button>
                </DialogActions>
            }
        </Dialog>
    )
}
